<template>
    <div class="lawyer-clues-info">
        <div class="title-box">
            <div class="title">
                即时线索
                <span ref="mainTitleTip" class="tip">
                    <!-- eslint-disable -->
                    <img
                        class="icon"
                        src="../../../assets/img/law/question.svg"
                    />
                </span>
                <veui-popover
                    target="mainTitleTip"
                >
                    即时线索是面向精英/尊享会员提供的专属权益，非会员需开通后享受该权益。</br>
                    在认领公海中认领与您匹配的线索，线索质量高、时效性高。</br>
                </veui-popover>
                <span class="yellow-icon">优质线索</span>
                <span class="yellow-icon">高时效性</span>
            </div>
            <div
                v-if="
                        (receivedInfo.can_use_business ||
                            (localStarInfo && localStarInfo.length))
                "
                class="clue-select"
            >
                <span class="clue-select-text"><img class="prompt" src="https://lvlin-base.cdn.bcebos.com/fe-saas/common/prompt.png">律所已授权，可切换使用</span>
                <veui-select
                    v-model="consume"
                    :options="consumeOptions"
                    class="select"
                    @change="changeConsumeType"
                />
            </div>
        </div>
        <div class="claimed-wrapper">
            <div class="claimed-box">
                <div class="claimed-in-month">
                    <!-- eslint-disable -->
                    <div class="title">
                        当前可认领线索数
                        <img
                            ref="tip4"
                            class="icon"
                            src="../../../assets/img/law/question.svg"
                            alt=""
                        />
                        <div class="number">
                            {{ receivedInfo.all_month_remain }}
                        </div>
                        <veui-popover target="tip4" position="bottom-center">
                            <span class="help-text">
                                {{consume === '0' ? '包含个人会员权益线索额度以及个人加购的线索包总额度' : '您的律所已购买会员且授权您共享线索认领权益'}}
                            </span>
                        </veui-popover>
                    </div>
                    <!-- eslint-enable -->
                </div>
                <div v-if="consume === '0'" class="claimed-in-month">
                    <!-- eslint-disable -->
                    <div class="title">
                        个人权益当月剩余
                        <img
                            ref="tip"
                            class="icon"
                            src="../../../assets/img/law/question.svg"
                            alt=""
                        />
                        <div class="number">
                            {{ receivedInfo.person_month_remain }}
                            <!-- 气泡 -->
                            <bubble
                                un-claimed-text="免费+5条"
                                expire-keywords="线索认领"
                            />
                        </div>
                        <veui-popover target="tip" position="bottom-center">
                            <span class="help-text">
                                包含个人会员权益线索剩余数以及个人加购的线索包剩余数
                            </span>
                        </veui-popover>
                    </div>
                    <!-- eslint-enable -->
                </div>
                <div v-if="consume === '1'" class="claimed-in-month">
                    <!-- eslint-disable -->
                    <div class="title">
                        律所权益当月剩余
                        <img
                            ref="tip1"
                            class="icon"
                            src="../../../assets/img/law/question.svg"
                            alt=""
                        />
                        <div class="number">
                            <span class="info-msg-num-value">
                                {{ receivedInfo.business_month_remain }}
                            </span>
                        </div>
                        <veui-popover target="tip1" position="bottom-center">
                            <span class="help-text">
                                律所授权剩余可认领线索数
                            </span>
                        </veui-popover>
                    </div>
                    <!-- eslint-enable -->
                </div>
                <div class="claimed-in-month">
                    <!-- eslint-disable -->
                    <div class="title">
                        累计认领线索数
                        <img
                            ref="tip-person-received"
                            class="icon"
                            src="../../../assets/img/law/question.svg"
                            alt=""
                        />
                        <div class="number">
                            {{ receivedInfo.all_month_received }}
                            <!-- 气泡 -->
                            <bubble
                                un-claimed-text="免费+5条"
                                expire-keywords="线索认领"
                            />
                        </div>
                        <veui-popover target="tip-person-received" position="bottom-center">
                            <span class="help-text">
                                {{ consume === '0' ? '个人累计认领的线索数' : '使用律所授权的权益累计认领的线索数' }}
                            </span>
                        </veui-popover>
                    </div>
                    <!-- eslint-enable -->
                </div>
                <div v-if="consume === '0'" class="claimed-in-month">
                    <!-- eslint-disable -->
                    <div class="title">
                        购买线索剩余
                        <img
                            ref="tip3"
                            class="icon"
                            src="../../../assets/img/law/question.svg"
                            alt=""
                        />
                        <div class="number">
                            <span class="info-msg-num-value"> 0 </span>
                        </div>
                        <veui-popover target="tip3" position="bottom-center">
                            <span class="help-text"
                                >通过增值加购线索包获得的领线索余量</span
                            >
                        </veui-popover>
                    </div>
                    <!-- eslint-enable -->
                </div>
            </div>
        </div>
        <!-- 免费体验会员 banner -->
        <freeVipBanner
            free-vip-words="去了解正式会员线索认领等11项专属权益吧"
            sub-title="一键领取平台精选优质线索，让案源获取更简单，体验期内任意领5条"
            expired-content="免费体验会员已到期，正式会员尊享线索认领等11项专属权益，快去了解吧"
        />
    </div>
</template>
<script>
import 'veui-theme-dls-icons';
import {Select, Popover} from 'veui';
import {mapState} from 'vuex';
import dayjs from 'dayjs';
import freeVipBanner from '@/components/vip/free-vip-banner.vue';
import bubble from '@/components/vip/bubble.vue';
/**
 * @file loading
 * @author liusihao
 */

export default {
    components: {
        'veui-popover': Popover,
        'veui-select': Select,
        freeVipBanner,
        bubble
    },
    props: {
        receivedInfo: {
            type: Object,
            default() {
                return {};
            }
        },
        consumeType: {
            type: String,
            default: ''
        },
        // 本地之星数据
        localStarInfo: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    watch: {
        consumeType() {
            this.consume = this.consumeType;
        }
    },
    computed: {
        ...mapState({
            vipInfo: state => state.lawStore.vipInfo || {}
        }),
        freeVipNotification() {
            const {vipStatusName, validityEnd} = this.vipInfo;
            const {person_month_remain} = this.receivedInfo;
            const remainDays = dayjs(validityEnd).diff(dayjs(), 'days');
            if (vipStatusName === 'freeVip') {
                return person_month_remain
                    ? `您的免费体验会员还有${remainDays}天到期，您还剩余${person_month_remain}次权益余额，请尽快使用~`
                    : '您的免费认领次数已用尽，联系客服开通正式会员享受完整权益~';
            }
            return '';

        }
    },
    data() {
        return {
            time: 0,
            currentTime: 0,
            //  1： 律所额度  0：会员额度
            consume: '0',
            consumeOptions: [
                {
                    label: '律所版权益',
                    value: '1'
                },
                {
                    label: '个人版权益',
                    value: '0'
                }
            ]
        };
    },
    methods: {
        changeConsumeType() {
            this.$emit('changeConsumeType', this.consume);
        },
        clickBubble(type) {
            this.$emit('clickBubble', type);
        }
    }
};
</script>
<style lang="stylus" scoped>
.lawyer-clues-info {
    background: #fff;
    border-radius: 8px;
    padding: 30px;
    box-sizing: border-box;
    box-shadow: 0 6px 14px 0 rgba(227, 233, 237, .35);

    .title-box {
        display: flex;
        justify-content: space-between;
        height: 16px;

        .title {
            font-family: PingFangSC-Semibold;
            font-size: 16px;
            color: #000;
            display: flex;
            align-items: center;
            line-height: 16px;
            font-weight: 500;

            .tip {
                display: inline-block;
                height: 14px;
                width: 14px;
                margin-left: 6px;
                margin-right: 10px;
                cursor: pointer;

                img {
                    height: 100%;
                    width: 100%;
                }
            }

            .yellow-icon {
                display: block;
                width: 60px;
                height: 16px;
                margin-right: 6px;
                border-radius: 8px;
                background-image: linear-gradient(90deg, #ffe99e 1%, #ffdc68 100%);
                font-family: PingFangSC-Regular;
                color: #a54300;
                font-size: 10px;
                line-height: 16px;
                text-align: center;
            }

            .vip-time-end {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #999;
                line-height: 14px;
                margin-left: 20px;
                font-weight: 400;
            }

            .free-vip-notification {
                margin-left: 20px;
                height: 20px;
                padding: 0 8px;
                display: inline-flex;
                align-items: center;
                background-image: linear-gradient(90deg, #ffe99e 1%, #ffdc68 100%);
                border-radius: 2px;
                font-family: PingFangSC-Regular;
                font-size: 12px;
                color: #9a490e;
                font-weight: 400;

                &::before {
                    content: "";
                    background: url("https://lvlin-base.cdn.bcebos.com/fe-saas/component/free-membership/icon-notification.png") no-repeat center / cover;
                    width: 14px;
                    height: 14px;
                    margin-right: 6px;
                }
            }
        }
        .clue-select {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            .clue-select-text {
                .prompt {
                    width: 10px;
                    height: 10px;
                    display: inline-block;
                    margin-right: 10px;
                }
                padding: 3px 8px;
                background: #FFD2A9;
                display: flex;
                align-items: center;
                border-radius: 8px;
                font-family: PingFang SC;
                font-size: 10px;
                line-height: 1;
                color: #A54300;
            }
        }

        .select {
            width: 120px;
            margin-left: 8px;
        }
    }

    .claimed-wrapper {
        margin-top: 24px;
        background: linear-gradient(90deg, rgba(231, 238, 255, .4) 30%, rgba(224, 230, 247, .4) 100%);
        background-size: 100% 100%;
        font-size: 13px;
        border-radius: 5px;

        .claimed-box {
            display: flex;
            justify-content: space-between;

            .claimed-in-month {
                position: relative;
                top: 4px;
                flex: 1;
                display: flex;
                justify-content: center;
                padding-top: 30px;
                padding-bottom: 30px;

                .title {
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #333;
                    line-height: 14px;

                    .icon {
                        width: 14px;
                        height: 14px;
                        margin-left: 3px;
                        vertical-align: bottom;
                        cursor: pointer;
                    }
                }

                .number {
                    font-family: HelveticaNeue-Bold;
                    font-size: 28px;
                    color: #282c33;
                    line-height: 28px;
                    font-weight: 700;
                    margin-top: 9px;
                    display: flex;
                    align-items: center;
                }
            }

            .claimed-in-month:not(:last-child) {
                margin-right: 20px;

                &::after {
                    content: "";
                    display: block;
                    width: 1px;
                    height: 48px;
                    background-color: rgba(51, 51, 51, .09);
                    position: absolute;
                    top: 30px;
                    right: 0;
                }
            }
        }
    }
}
</style>
